document.addEventListener('DOMContentLoaded', function() {
  var selectedVariantId = null;
  var maxQty = 0; // 3, 5, ou 7 selon la variante
  var totalSelected = 0;

  var variantCards = document.querySelectorAll('.pack-variant-card');
  var parfumsGrid = document.getElementById('parfums-grid');
  var addToCartBtn = document.getElementById('addPackToCart');

  // Sélectionner par défaut la variante "3 Parfums"
  function selectDefaultVariant() {
    const defaultVariantId = '50365220421933';
    const defaultCard = document.querySelector(`.pack-variant-card[data-variant-id="${defaultVariantId}"]`);
    
    if (defaultCard) {
      selectedVariantId = defaultVariantId;
      maxQty = 3;
      
      // Mettre à jour l'image principale
      const variantImageUrl = defaultCard.dataset.variantImage;
      const mainImage = document.getElementById('pack-decouverte-image');
      if (mainImage && variantImageUrl) {
        mainImage.src = variantImageUrl;
      }

      // Activer le bouton Commander
      addToCartBtn.disabled = false;

      // Ajouter la classe selected
      defaultCard.classList.add('selected');

      // Mettre à jour l'état des boutons
      updateAddButtonsState();
    }
  }

  // Appeler la fonction au chargement
  selectDefaultVariant();

  // 1) Quand on clique sur une carte de variante
  variantCards.forEach(function(card) {
    card.addEventListener('click', function() {
      selectedVariantId = card.dataset.variantId;
      var variantTitle = card.dataset.variantTitle;
      var variantImageUrl = card.dataset.variantImage;

      // Mettre à jour l'image principale
      var mainImage = document.getElementById('pack-decouverte-image');
      if (mainImage && variantImageUrl) {
        mainImage.src = variantImageUrl;
      }

      // On détermine la limite en fonction du titre
      var match = variantTitle.match(/\d+/);
      if (match) {
        const qty = parseInt(match[0], 10);
        // Utiliser directement les nouvelles quantités
        if (qty <= 3) maxQty = 3;
        else if (qty <= 5) maxQty = 5;
        else maxQty = 7;
      } else {
        maxQty = 3; // fallback
      }

      // on reset tous les compteurs
      totalSelected = 0;
      resetParfumsSelection();

      // on active le bouton "Commander" si on a une variante
      addToCartBtn.disabled = false;

      // Visuellement, mettre la carte sélectionnée en surbrillance
      variantCards.forEach(function(c){ c.classList.remove('selected'); });
      card.classList.add('selected');

      // Mettre à jour l'état des boutons "Ajouter"
      updateAddButtonsState();
    });
  });

  // 2) Gérer les +/- sur chaque parfum
  function resetParfumsSelection() {
    var cards = parfumsGrid.querySelectorAll('.parfum-card');
    cards.forEach(function(card) {
      card.querySelector('.qty-value').textContent = '0';
      card.querySelector('.parfum-qty').dataset.qty = 0;
      card.querySelector('.qty-decrease').disabled = true;
      card.querySelector('.qty-increase').disabled = (maxQty === 0);
      card.querySelector('.parfum-qty').classList.add('hidden');
      card.querySelector('.btn-add').classList.remove('hidden');
      card.querySelector('.btn-add').disabled = false; // Réactiver le bouton "Ajouter"
      card.classList.remove('selected');
    });
  }

  parfumsGrid.addEventListener('click', function(e) {
    var btn = e.target;
    var card = e.target.closest('.parfum-card');

    if (!card) return;

    // Si on clique sur l'image
    if (btn.tagName === 'IMG') {
      const qtyContainer = card.querySelector('.parfum-qty');
      const currentQty = parseInt(qtyContainer.dataset.qty || 0);
      const increaseBtn = card.querySelector('.qty-increase');
      
      // Si le bouton + est actif, simuler un clic dessus
      if (!increaseBtn.disabled) {
        if (currentQty === 0) {
          // Simuler le clic sur "Ajouter"
          const addBtn = card.querySelector('.btn-add');
          if (!addBtn.disabled) {
            addBtn.click();
            card.classList.add('selected');
          }
        } else {
          // Simuler le clic sur "+"
          increaseBtn.click();
        }
      }
      return;
    }

    // Si on clique sur le bouton Ajouter
    if (btn.classList.contains('btn-add') && !btn.disabled) {
      var qtyContainer = card.querySelector('.parfum-qty');
      // Initialiser la quantité à 1
      qtyContainer.dataset.qty = 1;
      card.querySelector('.qty-value').textContent = '1';
      totalSelected++;
      
      // Ajouter la classe selected
      card.classList.add('selected');

      // Cacher le bouton Ajouter et montrer les boutons + et -
      btn.classList.add('hidden');
      qtyContainer.classList.remove('hidden');

      // Activer/désactiver les boutons en fonction de la quantité
      card.querySelector('.qty-decrease').disabled = false;
      updateIncreaseButtonsState();
      updateAddButtonsState();
    }

    // Si on clique sur le bouton -
    if (btn.classList.contains('qty-decrease') && !btn.disabled) {
      var qtyContainer = card.querySelector('.parfum-qty');
      var currentQty = parseInt(qtyContainer.dataset.qty);
      
      if (currentQty > 0) {
        currentQty--;
        qtyContainer.dataset.qty = currentQty;
        card.querySelector('.qty-value').textContent = currentQty;
        totalSelected--;

        if (currentQty === 0) {
          // Si la quantité atteint 0, revenir à l'état initial
          qtyContainer.classList.add('hidden');
          card.querySelector('.btn-add').classList.remove('hidden');
          btn.disabled = true;
          // Retirer la classe selected
          card.classList.remove('selected');
        }

        updateIncreaseButtonsState();
        updateAddButtonsState();
      }
    }

    // Si on clique sur le bouton +
    if (btn.classList.contains('qty-increase') && !btn.disabled) {
      var qtyContainer = card.querySelector('.parfum-qty');
      var currentQty = parseInt(qtyContainer.dataset.qty);
      
      if (totalSelected < maxQty) {
        currentQty++;
        qtyContainer.dataset.qty = currentQty;
        card.querySelector('.qty-value').textContent = currentQty;
        totalSelected++;
        
        updateIncreaseButtonsState();
        updateAddButtonsState();
      }
    }
  });

  function updateAddButtonsState() {
    var cards = parfumsGrid.querySelectorAll('.parfum-card');
    
    // Désactiver tous les boutons "Ajouter" si aucune variante n'est sélectionnée
    if (!selectedVariantId) {
      cards.forEach(function(card) {
        card.querySelector('.btn-add').disabled = true;
      });
      addToCartBtn.disabled = true;
      return;
    }

    // Si on a atteint la quantité maximale, désactiver tous les boutons "Ajouter"
    if (totalSelected >= maxQty) {
      cards.forEach(function(card) {
        const qtyContainer = card.querySelector('.parfum-qty');
        const currentQty = parseInt(qtyContainer.dataset.qty || 0);
        if (currentQty === 0) {
          card.querySelector('.btn-add').disabled = true;
        }
      });
    } else {
      // Sinon, activer les boutons "Ajouter" pour les parfums non sélectionnés
      cards.forEach(function(card) {
        const qtyContainer = card.querySelector('.parfum-qty');
        const currentQty = parseInt(qtyContainer.dataset.qty || 0);
        if (currentQty === 0) {
          card.querySelector('.btn-add').disabled = false;
        }
      });
    }

    // Mettre à jour le bouton "Commander"
    addToCartBtn.disabled = (totalSelected !== maxQty);
  }

  function updateIncreaseButtonsState() {
    var cards = parfumsGrid.querySelectorAll('.parfum-card');
    
    cards.forEach(function(card) {
      var increaseBtn = card.querySelector('.qty-increase');
      var qtyContainer = card.querySelector('.parfum-qty');
      var currentQty = parseInt(qtyContainer.dataset.qty || 0);
      
      // Désactiver le bouton + si on a atteint la quantité maximale totale
      increaseBtn.disabled = (totalSelected >= maxQty);
    });

    // Mettre à jour le bouton "Commander"
    addToCartBtn.disabled = (totalSelected !== maxQty);
  }

  // 3) Ajax Add to cart
  addToCartBtn.addEventListener('click', function() {
    if (!selectedVariantId) {
      alert("Veuillez d'abord sélectionner un pack (3, 5 ou 7).");
      return;
    }

    // Récupérer tous les parfums sélectionnés
    var selectedParfums = [];
    var cards = parfumsGrid.querySelectorAll('.parfum-card');
    var index = 1;

    cards.forEach(function(card) {
      var qty = parseInt(card.querySelector('.parfum-qty').dataset.qty || 0);
      if (qty > 0) {
        var parfumName = card.dataset.parfumTitle;
        selectedParfums.push({
          name: parfumName,
          quantity: qty
        });
      }
    });

    // Préparer les propriétés pour l'ajout au panier
    var properties = {};
    
    // Format unique pour tous les affichages
    selectedParfums.forEach(function(parfum) {
      properties[parfum.name] = parfum.quantity;
    });

    // Ajouter au panier avec les propriétés
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: [{
          id: selectedVariantId,
          quantity: 1,
          properties: properties
        }]
      })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === 422) {
        throw new Error(data.description);
      }
      document.dispatchEvent(new Event('cart:added'));
      openCartDrawer();
    })
    .catch(error => {
      console.error('Error:', error);
      alert(error.message);
    });
  });

  // Fonction pour ouvrir le panier (sliding bag)
  function openCartDrawer() {
    // Utiliser le composant mini-cart pour ouvrir le panier
    var miniCart = document.querySelector('mini-cart');
    if (miniCart) {
      miniCart.open();
    }
  }

  // Fonction pour recharger les sections du panier
  function reloadCartSections() {
    var miniCart = document.querySelector('mini-cart');
    if (miniCart) {
      fetch('/cart.js')
        .then(response => response.json())
        .then(parsedState => {
          miniCart.renderContents(parsedState);
        })
        .catch(error => {
          console.error('Error reloading cart sections', error);
        });
    }
  }

  // Écouter l'événement cart:added pour recharger les sections du panier
  document.addEventListener('cart:added', function() {
    reloadCartSections();
  });
});
